import { render, staticRenderFns } from "./triggerList.vue?vue&type=template&id=3a4b12c9&scoped=true&"
import script from "./triggerList.vue?vue&type=script&lang=js&"
export * from "./triggerList.vue?vue&type=script&lang=js&"
import style0 from "./triggerList.vue?vue&type=style&index=0&id=3a4b12c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4b12c9",
  null
  
)

export default component.exports